// В production API проксируется через nginx (путь /api)
// В development режиме можно переопределить через REACT_APP_API_BASE_URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
export { API_BASE_URL };
